import { findFuelUrl } from '@/constants/forms-api.const';
import { RequestServices as _http } from '../common/request.services';

export const FeatureTogglesServices = {
  /**
   * Get Feature Toggles from sitecore 10
   * @returns
   */
  findFuel(lat: number, lng: number, fuelType: string) {
    return _http.HttpGet(
      findFuelUrl.replace('{0}', lat.toString()).replace('{1}', lng.toString()).replace('{2}', fuelType)
    );
  },
} as const;
